import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ru from './locales/ru.json';
import uz from './locales/uz.json';

/**
 * Site strings live under "site" so the admin preview can render site blocks with the same keys.
 */
export const siteMessages = { ru, uz, en };

/**
 * The page locale comes from the server: each language has its own address.
 */
export const createSiteI18n = (locale: string, fallbackLocale: string) =>
    createI18n({
        legacy: false,
        locale,
        fallbackLocale,
        messages: Object.fromEntries(Object.entries(siteMessages).map(([code, messages]) => [code, { site: messages }])),
    });
